module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The Border Lord")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "pdlmsr.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "adCardPage",
    attrs: {
      "id": "adc"
    }
  }, [_c('a', {
    attrs: {
      "id": "page05"
    }
  }, [_c('h2', {
    staticClass: "adCardHead"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Available from Harlequin")])])])]), _c('sup', [_vm._v("®")]), _c('span', {
    staticClass: "bold"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Historical and"), _c('br'), _vm._v("\nSOPHIA JAMES")])])])])]), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Fallen Angel")])]), _vm._v(" #171")])]), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Ashblane’s Lady")])]), _vm._v(" #838")])]), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Masquerading Mistress")])]), _vm._v(" #875")])]), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("High Seas to High Society")])]), _vm._v(" #888")])]), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("The Border Lord")])]), _vm._v(" #946")])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page05"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75dcefaa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/borderlordthe_adc.vue
// module id = 66
// module chunks = 0